import { FetchCarsOnTenderDocument, FetchCarsOnTenderQuery } from "@/graphql/__generated__/graphql";
import { useQuery } from "@apollo/client/react";
import { FetchCarsOnTenderQueryVariables } from "@/graphql/__generated__/graphql";

export const useFetchCarsOnTenderQueryHook = (currentTenderID: number) => {
  const { data, loading, refetch } = useQuery<FetchCarsOnTenderQuery, FetchCarsOnTenderQueryVariables>(
    FetchCarsOnTenderDocument, {
      variables: {
        tenderId: Number(currentTenderID)
      },
      fetchPolicy: "cache-and-network"
    });

  return {
    data, loading, refetch
  };
};
